import dataReducer from "./dataReducer";

// combine reducers and make them available
const reducers = {
    data: dataReducer
};

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/reducers.js